import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=74065c4e&scoped=true"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=74065c4e&prod&lang=css"
import style1 from "./QuestionAnswer.vue?vue&type=style&index=1&id=74065c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74065c4e",
  null
  
)

export default component.exports